import { render, staticRenderFns } from "./CopyStakeSettingsInactivityTimeout.vue?vue&type=template&id=d6ba8562&lang=pug"
import script from "./CopyStakeSettingsInactivityTimeout.vue?vue&type=script&lang=ts"
export * from "./CopyStakeSettingsInactivityTimeout.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeSettingsInactivityTimeout.vue?vue&type=style&index=0&id=d6ba8562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VForm,VRow,VTextField})
